import { useMutation } from "react-query";
import http from "infra/http";
import { AxiosError } from "axios";

function useExcluirEncomenda() {
  return useMutation<
    void,
    AxiosError,
    string
  >(
    async (id: string) => {
      await http.delete(`/v1/encomenda/${id}`);
    },
    { retry: false }
  );
}

export default useExcluirEncomenda;
